import CustomButton from '../../../../../../v2-components/Antd/Button';

export const showRecipeButtons = (status, renderButtons, setOpenRecipe) => {
	if (status === 1 || status === 101 || status === 2) {
		return renderButtons();
	}
	return <CustomButton onClick={() => setOpenRecipe(false)}>Salir</CustomButton>;
};
